<template>
  <div id="app">
    <router-view name="header" />
    <div class="wrapper">
      <router-view v-if="!path.includes('Detail')" name="carousel" />
      <router-view />
    </div>
    <!-- <router-view name="map" />
    <router-view name="totop" />
    <router-view name="contact" />
    <router-view name="footer" />
    <router-view v-if="windowWidth < 1024" name="footernav" /> -->
  </div>
</template>

<script>
import 'primevue/resources/themes/lara-light-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import 'vue-select/dist/vue-select.css'
import { mapActions } from "vuex";
export default {
  created() {
    this.path = this.$route.path;
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        this.path = this.$route.path;
      }
    );
  },

  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  data() {
    return {
      windowWidth: null,
      path: null,
    };
  },
  methods: {
    ...mapActions(["setHeightWindow", "setWidthWindow"]),
    handleResize() {
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      this.windowWidth = windowWidth;
      this.setHeightWindow(windowHeight);
      this.setWidthWindow(windowWidth);
    },
  },
};
</script>
